import axios from 'axios';
import { getAPIErrorReason } from '../helpers/common';
import { REACT_APP_TEAMCAMP_APIURL } from '../global/environment';
import { FeedbackPayloadInterface } from '../interfaces/helpCenterInterface';
import { captureException } from './logService';
import { rootStore } from '../mobx/rootStore';

export const sendFeedbackMessage = async (payload: FeedbackPayloadInterface) => {
  try {
    const response = await axios.post(`${REACT_APP_TEAMCAMP_APIURL}/contactUs`, payload);
    if (response) {
      return response;
    }
    return false;
  } catch (e) {
    const error = getAPIErrorReason(e) || 'Unable to send feedback please try again';
    captureException(error);
    dispatchSnapError(error);
  } finally {
  }
};

function dispatchSnapError(msg: string) {
  rootStore.alertNotificationStore.setErrorMessage(msg);
}
